import React, { useState } from "react";
import styles from "./styles/ButtonPopup.module.css";
import { capitalizeFirstLetter } from "../../../utils/utils";
/**
 * Customizable button component
 */
const ButtonPopup = ({
    body, // {String} - The button text
    size, // {String} - The size of the button, can be adapt, small or adapt
    // the adapt will make the component inherit the font size from parent element
    type, // {String} - The type of the button (button, submit)
    color, // {String} - The color of the button when hovered, default is the --current-color
    backgroundColor, // {String} - The background color of the button, default is --buttons-background
    onClickFuction, // {Function} - The function to call on button click
    grayClicked, // {Boolean} - Flag to gray the background when disabled (CSS)
    garyDisabled,
    disabled, // {Boolean} - Flag to disable the button in CSS
    setHoverFlag, // {Function} - Function to set the hover flag state (used in validation)
    disableHTML, // {Boolean} - Flag to disable the button in HTML
    active, // {Boolean} - Flag to indicate if the button is active
    fullWidth, // {Boolean} - Flag to make the button full width
    data, // {String} - Additional data saved in the element
    popup,
}) => {
    /**
     * Custom disable the button in conjunction with hoverFlag
     * set the hover flag to true when hovered
     */
    const [innerHoverFlag, setInnerHoverFlag] = useState(false);
    const handleHover = (requiredFlag) => {
        setHoverFlag && setHoverFlag(requiredFlag);
        setInnerHoverFlag(requiredFlag);
    };

    return (
        <div
            className={` ${styles.button_container} ${
                fullWidth ? styles.full_width : ""
            } `}
        >
            {popup ? (
                <div
                    className={` ${styles.popup_container} ${
                        innerHoverFlag && disabled ? styles.popup_fade_in : ""
                    }`}
                >
                    <p className={` ${styles.popup}`}>
                        {capitalizeFirstLetter(popup)}
                    </p>
                </div>
            ) : (
                <></>
            )}
            <button
                className={`${styles.button_base} ${
                    size === "adapt"
                        ? styles.adapt
                        : size === "small"
                        ? styles.small
                        : styles.standard
                } ${
                    disabled
                        ? styles.button_disable
                        : color === "red"
                        ? styles.button_red
                        : color === "green"
                        ? styles.button_green
                        : backgroundColor === "red"
                        ? styles.button_red_background
                        : backgroundColor === "green"
                        ? styles.button_green_background
                        : styles.button
                }  ${grayClicked ? styles.grayed : ""} ${
                    disabled ? styles.button_disable : ""
                }  ${garyDisabled ? styles.gray_Disabled : ""} ${
                    active ? styles.active : ""
                } ${fullWidth ? styles.full_width : ""}`}
                onMouseEnter={() => handleHover(true)}
                onMouseLeave={() => handleHover(false)}
                onClick={onClickFuction}
                type={type}
                value={body}
                aria-label={`${body} button`}
                disabled={disableHTML}
                data-ex={data}
            >
                {body}
            </button>
        </div>
    );
};

export default ButtonPopup;
